import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as physicalConfirmationAction from '../../../actions/physicalConfirmationAction';
import { translate, downloadFile, isNullOrEmpty, formatData, leftPad, closeCollapsible, showMessageToastCustom } from '../../../utils/util';
import { Breadcrumbs, Button, Input, ListPagination, Modal, Select, SelectResource, Collapsible } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { ENUMS } from '../../../utils/constants'
import ScannerCode from '../../../components/UI/ScannerCode';
import SelectResourceMvi from '../../TruckKanban/Space/Mvi/SelectResourceMvi';
import TruckKanbanService from '../../../services/TruckKanbanService';

const GeneralReport = (props) => {
    const [openModal, setOpenModal] = useState(false);
    const [openModalMvi, setOpenModalMvi] = useState({ open: false, mviId: undefined });
    const [printer, setPrinter] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [reportItems, setReportItems] = useState();
    const [arrayDrop, setArrayDrop] = useState([]);
    const [filter, setFilter] = useState(
        {
            id: "",
            mvmNumber: "",
            journey: "",
            initialDate: "",
            finalDate: "",
            shedList: [],
            status: "",
            printer: props.user?.printer,
            partnumbercode: "",
            driver: "",
            plate: "",
            cim: "",
        });
    const [orderDirection, setOrderDirection] = useState("ASC")

    useEffect(() => {
        if (reportItems?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(reportItems.items);
            } else {
                setData((prevState) => ([...prevState, ...reportItems.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [reportItems?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        props.getShedList();
        document.addEventListener('keydown', handleFormKeyDown);

        return () => {
            setData([]);
            setReportItems();
            document.removeEventListener('keydown', handleFormKeyDown);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.shedList && props.shedList.length > 0) {
            setArrayDrop(props.shedList.map(shed => { return { id: shed, text: shed }; }));
        }
        // eslint-disable-next-line
    }, [props.shedList]);

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setData([]);
            }
            props.getListGeneralReport(filter, {
                PageSize: 25,
                PageIndex: currentPageList,
                OrderDirection: orderDirection,
            }, (data) => {
                setReportItems(data);
                if (click) {
                    closeCollapsible("collapsible2")
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const downloadCsv = () => {
        if (validateMonth()) {
            props.getGeneralReport(filter, (data) => {
                downloadFile(data, `FileLog${Date.now()}.csv`, "data:text/csv", true);
            });
        }
    }

    const handleMvmJourney = (item) => {
        if (item.mvmNumber) {
            return item.journey ? "MVM: " + item.mvmNumber + " /  Viagem: " + item.journey : "MVM: " + item.mvmNumber;
        }

        return "Viagem: " + item.journey
    }

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onFilter(true)
        }
    }

    const renderItem = (item, index) => {
        return (
            <>
                {
                    !isNullOrEmpty(item.mvi) ?
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '0px', right: '85px', zIndex: '999' }}
                        ><i onClick={() => {
                            setOpenModalMvi({ open: true, mviId: item.mvi })
                        }} className={`mdi mdi-36px mdi-truck-delivery`} />
                        </span>

                        :
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999', cursor: 'pointer' }}
                        ><i onClick={() => {
                            filter.id = item.id;
                            filter.shedFilter = item.shed;
                            setFilter(filter);
                            setOpenModal(true)
                        }} className={`mdi mdi-36px mdi-printer`} />
                        </span>
                }
                <span
                    className="title sixth-text-color right"
                    style={{ position: 'absolute', marginTop: '0px', right: '50px', zIndex: '999', cursor: 'pointer' }}>
                    <i onClick={() => {
                        if (!isNullOrEmpty(item.mvi)) {
                            props.history.replace({ pathname: '../V2/searchmvi', state: { mvi: item.mvi }, ...props });
                        }
                        else {
                            props.setFilter({
                                mvmNumber: item.mvmNumber,
                                journey: item.mvmNumber !== '' ? '' : item.journey,
                            })
                            props.history.push({ pathname: '../V2/receiptStorages', state: { forceSearch: true }, ...props });
                        }
                    }} className={`mdi mdi-36px mdi-clipboard-check-outline`} />
                </span >
                <div
                    style={{ display: 'block', padding: '10px', height: 'auto' }}
                    key={`oi-${index}`}
                >
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <b className="col s12" style={{ color: 'black' }}>
                            {handleMvmJourney(item)}
                        </b>
                    </div>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <div className="col s6">
                            <label>{` ${translate('physical-confirmation:shed')}: ${(item.shed) ? item.shed : 'N/A'}`}</label>
                        </div>
                        <div className="col s6">
                            <label>{` ${translate('general:status')}: ${(item.status) ? item.status : ''}`}</label>
                        </div>
                        <div className="col s6">
                            <label>{` ${translate('physical-confirmation:invoice')}: ${(item.invoice) ? item.invoice : 'N/A'}`}</label>
                        </div>
                        <div className="col s6">
                            <label>{` ${translate('physical-confirmation:quantity')}: ${(item.qtdPartNumbers) ? item.qtdPartNumbers : 'N/A'}`}</label>
                        </div>
                        <div className="col s12">
                            <label>{` ${translate('physical-confirmation:supplier')}: ${(item.suppliers) ? item.suppliers : 'N/A'}`}</label>
                        </div>
                        <div className="col s12">
                            <label>{` ${translate('physical-confirmation:plate')}: ${(item.plate) ? item.plate : 'N/A'}`} {` ${translate('physical-confirmation:driver')}: ${(item.driver) ? item.driver : 'N/A'}`}</label>
                        </div>
                        <div className="col s12">
                            <label>{` ${translate('physical-confirmation:receipt-click')}: ${(item.createdOn) ? formatData(item?.createdOn) : ''}`}</label>
                        </div>
                        <div className="col s12">
                            <label>{` ${translate('physical-confirmation:mvi')}: ${item.mvi}`}</label>
                        </div>
                    </div>
                    <Modal
                        open={openModalMvi.open}
                        id="ModalPrintDownload"
                        content={`Relatorio MVI ${openModalMvi.mviId}`}
                        children={<SelectResourceMvi onChangePrinter={(printer) => {
                            setPrinter(printer);
                        }} />}
                        dismissible={false}
                        onConfirm={() => props.sendReportPrinter(printer, openModalMvi.mviId, () => {
                            setOpenModalMvi({ open: false, mviId: undefined })
                        })}
                        onCancel={() => onReportMvi(openModalMvi.mviId)}
                        btnCancel="Baixar"
                        btnConfirm="Enviar Impressora"
                        closeModal={() => setOpenModalMvi({ open: false, mviId: undefined })}
                    />
                </div>
            </>
        )
    }

    const renderSelectResource = () => {
        return (
            <div id="renderSelectResource" className='row'>
                <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '10px' }}>
                    <div className="input-field col s12">
                        <SelectResource
                            required
                            printLaser
                            name="resource"
                            id="resource"
                            value={props.resourceReport.resourceId || props.user?.resourceLaser}
                            onChange={onChangeResource} />
                    </div>
                    <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
                        {translate('message-report-print', 'physical-confirmation')}
                    </div>
                </div>
            </div>
        );
    }

    const onChangeResource = (el) => {
        if (!isNullOrEmpty(el.target.value)) {
            let resource = props.resources.find((i) => i.resourceId === parseInt(el.target.value));
            if (resource?.printer) {
                props.setResourceReport(resource);
            }
        }
        else {
            props.setResourceReport({});
        }
    }

    const sendReportPrinter = (sendPrinter) => {
        setOpenModal(false);
        filter.printer = props.user?.printer
        filter.SendPrinter = sendPrinter;
        props.ReportPdfPrinter(filter, (response) => {
            downloadFile(response, `cf${filter.id}.pdf`, "data:application/pdf", true)
        })
    }

    const addShedFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.shedList = Array.from(selectedOptions).map(x => x.value)
            setFilter(finalFilter);
        }
    }

    const addShedFilterAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.shedList.push(item)
            setFilter(finalFilter);
        }
    };

    const updateOrder = () => {
        window.scrollTo(0, 0)
        let newOrder = orderDirection === "ASC" ? "DESC" : "ASC";
        setOrderDirection(newOrder)
        setData([])
        setCurrentPage(0);
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.value && !isNullOrEmpty(e.target.value)) {
            onQrCodeReadHandler(e.target.value, false);
        }
    }
    const onQrCodeReadHandler = (data) => {
        if (!isNullOrEmpty(data)) {
            var cim = "";
            if (data.split('-').length > 1) {
                cim = data.split('-')[1]
            } else {
                cim = data;
            }

            const filterObj = {};
            Object.assign(filterObj, filter);
            filterObj.cim = cim;
            filterObj.mvi = true;

            setFilter({ ...filterObj });
        }
    }

    const validateMonth = () => {
        var data1 = new Date(filter.initialDate);
        var data2 = new Date(filter.finalDate);
        var total = (data2.getFullYear() - data1.getFullYear()) * 12 + (data2.getMonth() - data1.getMonth());
        if (total > 3) {
            showMessageToastCustom(translate('warning', 'general'), "Permitido apenas período de 3 Meses", 8000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }
        return true;
    }

    const onReportMvi = (id) => {
        setOpenModalMvi({ open: false, mviId: undefined })
        props.getReport(id, (response) => {
            downloadFile(response, `mvi${id}.pdf`, "data:application/pdf", true)
        });
    }

    const requiredDate = () => {
        if (!isNullOrEmpty(filter.journey) || !isNullOrEmpty(filter.mvmNumber)) {
            return false;
        }

        return true
    }

    return (
        <div>
            <Breadcrumbs id="reportTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: translate('physical-confirmation:reports-and-rmd') }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            defaultValue={filter.initialDate}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="initialDate"
                                            name="initialDate"
                                            required={requiredDate()}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.finalDate}
                                            type="date"
                                            label={translate('change-location:endDate')}
                                            id="finalDate"
                                            name="finalDate"
                                            required={requiredDate()}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="mvmNumber"
                                            name='mvmNumber'
                                            label={translate('physical-confirmation:mvm')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="journey"
                                            name='journey'
                                            label={translate('physical-confirmation:journey')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="invoice"
                                            name='invoice'
                                            label={translate('physical-confirmation:invoice')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="driver"
                                            name='driver'
                                            label={translate('physical-confirmation:driver')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="plate"
                                            name='plate'
                                            label={translate('physical-confirmation:plate')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="partnumbercode"
                                            name='partnumbercode'
                                            label={translate('physical-confirmation:part-number')}
                                            type="text"
                                            onChange={onChange}
                                            numericonly="true"
                                            value={filter.partnumbercode}
                                            maxLength={11}
                                            onBlur={(ev) => {
                                                const formatted = leftPad(ev.target.value, 11, '0');

                                                if (ev.target.value.length === 0 || formatted === ev.target.value) {
                                                    return;
                                                }

                                                ev.target.value = formatted;
                                                onChange(ev);
                                            }}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Select
                                            id="status"
                                            name="status"
                                            display="description"
                                            change={onChange}
                                            defaultValue={""}
                                            label={translate('general:status')}
                                            data={[{ id: ENUMS.eMvmStatus.InProgress.value, text: translate("physical-confirmation:running"), },
                                            { id: ENUMS.eMvmStatus.Awaiting.value, text: translate("physical-confirmation:pending") },
                                            { id: ENUMS.eMvmStatus.Finished.value, text: translate("physical-confirmation:finished") }
                                            ]}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Select
                                            id="shed"
                                            name="shed"
                                            display="description"
                                            change={addShedFilter}
                                            multiple={true}
                                            changeAll={addShedFilterAll}
                                            label={translate('physical-confirmation:shed')}
                                            disablePlaceHoderSelect={true}
                                            data={arrayDrop}
                                            clearAll={() => {
                                                filter.shedList = [];
                                                setFilter({ ...filter });
                                            }}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s11" style={{ marginLeft: '10px' }}>
                                        <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={onQrCodeReadHandler} />
                                        <Input
                                            onKeyDown={(e) => handleOnKeyDown(e)}
                                            id="cim"
                                            name="cim"
                                            label={`${translate('truck-kanban:qrCode')}/CIM`}
                                            type="text"
                                            onChange={(evt) => {
                                                if (evt.target.value.length > 9) {
                                                    onQrCodeReadHandler(evt.target.value)
                                                }
                                                onChange(evt);
                                            }}
                                            value={filter.cim}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </>
                        }
                    />
                    {
                        data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadCsv} full="true" text={translate('general.generateReport')} />
                        </div>
                    }
                </div>
                {data.length > 0 &&
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div onClick={() => updateOrder()} className="sixth-text-color flex-center" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} >
                            <i className={`mdi mdi-menu-${orderDirection === "ASC" ? 'up' : 'down'} f24`} />
                            <b>{translate('order', 'general')}</b>
                        </div>
                    </div>
                }
                <div id="list" style={{ marginLeft: '5px' }}>
                    <ListPagination
                        page={reportItems?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item, index) => {
                                return renderItem(item, index);
                            })
                        }
                    />
                </div>
            </div>
            <Modal
                open={openModal}
                id="ModalPrintDownloadMvm"
                content={`Relatorio MVM/Viagem`}
                children={renderSelectResource()}
                dismissible={false}
                onConfirm={() => {
                    sendReportPrinter(true)
                }}
                onCancel={() => sendReportPrinter(false)}
                closeModal={() => setOpenModal(false)}
                btnCancel="Baixar"
                btnConfirm="Enviar Impressora"
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resourceReport: state.physicalConfirmationReducer.resourceReport,
        resources: state.logisticsResourceReducer.list,
        shedList: state.physicalConfirmationReducer.sheds
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListGeneralReport: (filter, pagination, callback) => {
            dispatch(PhysicalConfirmationService.getListGeneralReport(filter, pagination, callback));
        },
        getGeneralReport: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getGeneralReport(filter, callback));
        },
        ReportPdfPrinter: (filter, callback) => {
            dispatch(PhysicalConfirmationService.reportPdfPrinter(filter, callback));
        },
        getShedList: () => {
            dispatch(PhysicalConfirmationService.getShedList())
        },
        setResourceReport: (resource) => {
            dispatch(physicalConfirmationAction.setResourceReport(resource));
        },
        setFilter: (filter) => {
            dispatch(physicalConfirmationAction.setFilter(filter));
        },
        sendReportPrinter: (printer, id, callback) => {
            dispatch(TruckKanbanService.sendReportFileMvi(printer, id, callback));
        },
        getReport: (id, callback) => {
            dispatch(TruckKanbanService.getReportMvi(id, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GeneralReport)));
